import { GET_LIST } from 'react-admin';

export const apiUrl = import.meta.env.VITE_API_URL;
//const apiUrl = "https://api.clientesinoelec.com";

export const BASE_URL = `${apiUrl}/api`;
export const BASE_URL_API_NO = apiUrl;

// Configuración del Hub de WebSocket
export const WEBSOCKET_HUB_URL = `${apiUrl}/variablesStreamingHub`;

// Puntos de enlace de WebSocket (WebSocket endpoints)
export const WEBSOCKET_ENDPOINTS = {
  VARIABLES_STREAMING_HUB: `${apiUrl}/variablesStreamingHub`,
};

export const API_ENDPOINTS = {
  USERS: {
    LOGIN: `${BASE_URL}/Users/login`,
    REFRESH: `${BASE_URL}/Users/refresh`, // Agrega el punto de enlace para refrescar el token
    LOGGED: `${BASE_URL}/Users/logged`, // Punto de enlace para verificar si el usuario ha iniciado sesión
  },
  CLIENTS: {
    PLANT_DASHBOARD_TREE: `${BASE_URL}/Clients/plant-dashboard-tree`,
  },
  LAYOUTS: {
    BY_DASHBOARD: (dashboardId: number) =>
      `${BASE_URL}/Layouts/ByDashboard/${dashboardId}`,
    UPDATE: (layoutId: number) => `${BASE_URL}/Layouts/${layoutId}`,
    CREATE: `${BASE_URL}/Layouts`,
    DELETE: (layoutId: number) => `${BASE_URL}/Layouts/${layoutId}`, // Punto de enlace DELETE agregado
    BULK_UPDATE: `${BASE_URL}/Layouts/bulk`, // Nuevo punto de enlace para actualización masiva
  },
  CHART_QUERIES: {
    CREATE: `${BASE_URL}/ChartQueries`,
    BY_LAYOUT: (layoutId: number) =>
      `${BASE_URL}/ChartQueries/ByLayout/${layoutId}`,
    BY_VALUE_NODE: (nodeId: number) =>
      `${BASE_URL}/ChartQueries/ByValueNode/${nodeId}`,
    UPDATE: (chartQueryId: number) =>
      `${BASE_URL}/ChartQueries/${chartQueryId}`,
    GET_BY_ID: (chartQueryId: number) =>
      `${BASE_URL}/ChartQueries/${chartQueryId}`,
    APPLY_FILTERS_BY_DASHBOARD: (dashboardId: number) =>
      `${BASE_URL}/ChartQueries/ApplyFiltersByDashboardId/${dashboardId}`,
  },
  PLANTS: {
    GET_ALL: `${BASE_URL}/Plants`,
    BY_ID: (plantId: number) => `${BASE_URL}/Plants/${plantId}`,
  },
  ZONES: {
    BY_PLANT: (plantId: number) => `${BASE_URL}/Zones/ByPlant/${plantId}`,
    BY_ID: (zoneId: number) => `${BASE_URL}/Zones/${zoneId}`,
  },
  TABLES: {
    BY_ZONE: (zoneId: number) => `${BASE_URL}/Tables/ByZone/${zoneId}`,
  },
  VARIABLES: {
    VARIABLES_BY_ID: (variableId: number) =>
      `${BASE_URL}/Variables/${variableId}`,
    POST_SCADA_VARIABLE: (plantId: number) =>
      `${BASE_URL}/VariablesBulk/${plantId}`,
    INPUT_BY_TABLE: (tableId: number) =>
      `${BASE_URL}/Variables/input/by-table/${tableId}`,
    DEVICE_BY_PLANT: (plantId: number) =>
      `${BASE_URL}/Variables/Device/ByPlant/${plantId}`,
    DEVICE_BY_ID: (deviceId: number) =>
      `${BASE_URL}/Variables/Device/${deviceId}`,
    GET_SCADA_BY_ID: (zoneId: number) =>
      `${BASE_URL}/Variables/scada/by-zone/${zoneId}`, //variable por zona
    BY_TABLE: (tableId: number) =>
      `${BASE_URL}/Variables/scada/by-table/${tableId}`, //variable por tabla
    GET_SCADA_BY_PLANT: (plantId: number) =>
      `${BASE_URL}/Variables/scada/by-plant/${plantId}`, //variable por planta
    TASK_BY_TABLE: (tableId: number) =>
      `${BASE_URL}/Variables/task/by-table/${tableId}`,
    TASK_BY_ZONE: (zoneId: number) =>
      `${BASE_URL}/Variables/task/by-zone/${zoneId}`,
    TASK_BY_PLANT: (plantId: number) =>
      `${BASE_URL}/Variables/task/by-plant/${plantId}`,
    TASK_BY_ID: (taskId: number) => `${BASE_URL}/Variables/task/${taskId}`,
    TASK_TREE: (taskId: number) =>
      `${BASE_URL}/Variables/task/tree?taskId=${taskId}`,
    TASK_FILTER: `${BASE_URL}/Variables/task/filter`,
    CREATE_TASK: `${BASE_URL}/Variables/task`,
    UPDATE_TASK: `${BASE_URL}/Variables/task`,
    DELETE_TASK: (taskId: number) => `${BASE_URL}/Variables?id=${taskId}`,
    CHECK_VARIABLE_TASK: `${BASE_URL}/Variables/tasks/check-variable-task`,
    TEST_VARIABLE_TASK: `${BASE_URL}/Variables/tasks/test-variable-task`,
    GET_DATA: (variableId: number) =>
      `${BASE_URL}/Variables/GetDataFromVariable/${variableId}`,
    GET_LIVE_DATA: (dashboardId: number) =>
      `${BASE_URL}/Variables/GetLastDataByDashboardId/${dashboardId}`,
    GET_DIAGRAM_VARIABLES: (diagramId: number) =>
      `${BASE_URL}/Variables/GetLastDataFromDiagramId/${diagramId}`,
    EXPORT_DATA: `${BASE_URL}/Variables/ExportData`,
    INGEST_VARIABLES: `${BASE_URL}/Variables/ingest`, // Nuevo punto de enlace para la ingesta de variables
  },
  DASHBOARDS: {
    CREATE: `${BASE_URL}/Dashboards`,
    GET_BY_ID: (dashboardId: number) => `${BASE_URL}/Dashboards/${dashboardId}`,
    BY_GROUP: (dashboardGroupId: number) =>
      `${BASE_URL}/Dashboards/ByDashboardGroup/${dashboardGroupId}`,
    RANGE: `${BASE_URL}/Dashboards/range`, // Nuevo punto de enlace de actualización de rango
  },
  DASHBOARD_GROUPS: {
    BY_PLANT: (plantId: number) =>
      `${BASE_URL}/DashboardGroups/ByPlant?id=${plantId}`,

    BY_ID: (dashboardGroupId: number) =>
      `${BASE_URL}/DashboardGroups/${dashboardGroupId}`,
    UPDATE_RANGE: `${BASE_URL}/DashboardGroups/range`,
  },
  DIAGRAMS: {
    GET_ALL: `${BASE_URL}/Diagrams`,
    GET_BY_ID: (diagramId: number) =>
      `${BASE_URL}/Diagrams/${diagramId}?include=nodes,edges`,
    GET_BY_PLANT: (plantId: number) =>
      `${BASE_URL}/Diagrams/ByPlant/${plantId}`,
    CREATE: `${BASE_URL}/Diagrams`,
    UPDATE: (diagramId: number) => `${BASE_URL}/Diagrams/${diagramId}`,
    DELETE: (diagramId: number) => `${BASE_URL}/Diagrams/${diagramId}`, // Puntos de enlace de nodos
    NODES: {
      GET_BY_DIAGRAM: (diagramId: number) =>
        `${BASE_URL}/Diagrams/${diagramId}/nodes`,
      GET_BY_ID: (nodeId: number) => `${BASE_URL}/DiagramNode/${nodeId}`,
      CREATE: `${BASE_URL}/DiagramNode`,
      UPDATE: (nodeId: string) => `${BASE_URL}/DiagramNode/${nodeId}`,
      DELETE: (nodeId: string) => `${BASE_URL}/DiagramNode/${nodeId}`,
      BULK_UPDATE: `${BASE_URL}/DiagramNode/bulk`,
      BULK_POSITION_UPDATE: `${BASE_URL}/DiagramNode/bulk`,
    },

    // Puntos de enlace de bordes (Edges)
    EDGES: {
      GET_BY_DIAGRAM: (diagramId: number) =>
        `${BASE_URL}/Diagrams/${diagramId}/edges`,
      CREATE: `${BASE_URL}/DiagramEdges`,
      UPDATE: (edgeId: string) => `${BASE_URL}/DiagramEdges/${edgeId}`,
      DELETE: (edgeId: string) => `${BASE_URL}/DiagramEdges/${edgeId}`,
      BULK_UPDATE: `${BASE_URL}/DiagramEdges/bulk`,
    },
  },
  ALERTS: {
    CREATE: `${BASE_URL}/Alerts`,
    UPDATE: `${BASE_URL}/Alerts`,
    GET_ALL: `${BASE_URL}/Alerts`,
    GET_BY_ID: (alertId: number) => `${BASE_URL}/Alerts/${alertId}`,
    DELETE: (alertId: number) => `${BASE_URL}/Alerts/${alertId}`,
    BY_PLANT: (plantId: number) => `${BASE_URL}/Alerts/byPlant/${plantId}`,
    BY_VARIABLE: (variableId: number) =>
      `${BASE_URL}/Alerts/byVariable/${variableId}`,
    BY_ZONE: (zoneId: number) => `${BASE_URL}/Alerts/byZone/${zoneId}`,
    ACKNOWLEDGE: (alertId: number) =>
      `${BASE_URL}/Alerts/${alertId}/acknowledge`,
    EXECUTION_LAST: (alertId: number) =>
      `${BASE_URL}/Alerts/execution/last/${alertId}`,
  },
  STATISTICS: {
    GENERAL: `${BASE_URL}/Statistics/general`,
  },
  EXPORTS: {
    CREATE_EXPORT: `${BASE_URL}/Export`,
    GET_EXPORT_BY_ID: (exportId: number) => `${BASE_URL}/Export/${exportId}`,
    GET_EXPORT_BY_USER: (userId: string) =>
      `${BASE_URL}/Export/byUser/${userId}`,
    DELETE_EXPORT: (exportId: number) => `${BASE_URL}/Export/${exportId}`,
    // Previsualiza una plantilla con un rango de fechas -> devuelve un archivo (blob)
    PREVIEW_TEMPLATE: (templateId: number) =>
      `${BASE_URL}/Export/template/${templateId}/download`,
  },
  ANNOTATIONS: {
    GET_BY_ZONE: (zoneId: number) =>
      `${BASE_URL}/Annotations/by-zone/${zoneId}`,
    GET_BY_ID: (annotationId: number) =>
      `${BASE_URL}/Annotations/${annotationId}`,
    CREATE: `${BASE_URL}/Annotations`,
    UPDATE: (annotationId: number) => `${BASE_URL}/Annotations/${annotationId}`,
    DELETE: (annotationId: number) => `${BASE_URL}/Annotations/${annotationId}`,
    GET_HISTORY: (annotationId: number, from: string, to: string) =>
      `${BASE_URL}/AnnotationsData/by-annotation-dates?annotationId=${annotationId}&from=${from}&to=${to}`,
    CREATE_TEXT_ANNOTATION: `${BASE_URL}/AnnotationsData`, // Nuevo punto de enlace para crear anotaciones de texto
    DELETE_ANNOTATION_TEXT: (annotationTextId: number) =>
      `${BASE_URL}/AnnotationsData/${annotationTextId}`, // Punto de enlace para eliminar una anotación de texto
    EDIT_ANOTATION_TEXT: (annotationTextId: number) =>
      `${BASE_URL}/AnnotationsData/${annotationTextId}`, // Punto de enlace para editar una anotación de texto
    GET_ANNOTATION_DATA_BY_ID: (annotationTextId: number) =>
      `${BASE_URL}/AnnotationsData/${annotationTextId}`, // Punto de enlace para obtener la anotación por ID
  },
  TEMPLATES: {
    GET_BY_PLANT: (plantId: number) =>
      `${BASE_URL}/ExportTemplate/plant/${plantId}`,
    GET_BY_ID: (templateId: number) =>
      `${BASE_URL}/ExportTemplate/${templateId}`,
    CREATE: `${BASE_URL}/ExportTemplate`,
    UPDATE: (templateId: number) => `${BASE_URL}/ExportTemplate/${templateId}`,
    DELETE: (templateId: number) => `${BASE_URL}/ExportTemplate/${templateId}`,
    DOWNLOAD: (templateId: number) =>
      `${BASE_URL}/ExportTemplate/${templateId}/download`,
    // Punto de enlace utilizado por el enlace de descarga externo (parámetros de consulta: exportTemplateId, from, to)
    DOWNLOAD_FILE: `${BASE_URL}/export-template/download-file`,
  },
  TEMPLATE_EXPORT_SCHEDULE: {
    CREATE: `${BASE_URL}/TemplateExportSchedule`,
    GET_ALL: `${BASE_URL}/TemplateExportSchedule`,
    GET_BY_ID: (id: number) => `${BASE_URL}/TemplateExportSchedule/${id}`,
    DELETE: (id: number) => `${BASE_URL}/TemplateExportSchedule/${id}`,
    // Envía la plantilla rellenada a una lista de correos electrónicos (espera { exportTemplateId, from, to, emails: string[] })
    SEND: `${BASE_URL}/TemplateExportSchedule/send`,
  },
  TEMPLATES_WITH_SLOTS: {
    BY_PLANT_WITH_SLOTS: (plantId: number) =>
      `${BASE_URL}/ExportTemplate/plant/${plantId}/withslots`,
  },
  NOTIFICATIONS: {
    GET_ALL: `${BASE_URL}/Notifications`,
    MARK_READ: (notificationId: number) =>
      `${BASE_URL}/Notifications/${notificationId}/mark-read`,
    UNREAD_COUNT: `${BASE_URL}/Notifications/unread-count`,
  },
  TICKET: {
    GET_MY_TICKETS: `${BASE_URL}/Tickets`,
    CREATE_TICKET: `${BASE_URL}/Tickets`,
    GET_TICKET_BY_ID: (ticketId: number) => `${BASE_URL}/Tickets/${ticketId}`,
    UPDATE_TICKET: (ticketId: number) => `${BASE_URL}/Tickets/${ticketId}`,
    DELETE: (ticketId: number) => `${BASE_URL}/Tickets/${ticketId}`,
  },
};

export const API_URLS = {
  dashboards: {
    create: '/Dashboards',
    byGroup: '/Dashboards/ByDashboardGroup',
  },
};

export const apiConfig = {
  endpoints: {
    dashboardGroups: `${BASE_URL}/DashboardGroups`,
    dashboards: `${BASE_URL}/Dashboards`,
  },
};
